export default {
  'btn.send': 'Send',
  'btn.ok': 'OK',
  'btn.enter': 'Enter',
  'btn.beFast': 'OK',
};
